import React from 'react';
import Checkbox from 'lib/Checkbox';
import { SelectedFramesSectionProps } from './FrameListPanel.types';

export const SelectedFramesSection: React.FC<SelectedFramesSectionProps> = ({
  manuallySelectedFrames,
  handleRemoveFrame,
}) => {
  if (!manuallySelectedFrames.length) return null;

  return (
    <div className="border-t border-neutral-200 py-2">
      <div className="px-4 py-1 text-sm font-medium text-neutral-700">Selected ({manuallySelectedFrames.length})</div>
      {manuallySelectedFrames.map((frame) => (
        <div key={`selected-${frame.code}-${frame.mediaOwner}`} className="px-4 py-2 hover:bg-neutral-50">
          <Checkbox
            value={frame.code}
            label={frame.code}
            isSelected
            onChange={() => handleRemoveFrame(frame.code, frame.mediaOwner)}
          />
        </div>
      ))}
    </div>
  );
};
